import React from 'react';
import _isEmpty from 'lodash.isempty';
import { ADDON_TYPE } from '@shootsta/common-domain-data';
import AddonViewV2 from '../../AddonViewV2';
import { getAddonType } from '../../../../../common/utils';
import CommonAddonView from '../../CommonAddonView';
import { Text } from '../../../../../ui-kit';










function GroupedAddonList(props) {
  const groupAddons = (
  addonsList = [],
  getAdditionalOutputs,
  getCaptions) =>
  addonsList.reduce(
    (summary, addon) => {
      const addonType = getAddonType(addon);
      if (!addonType) return summary;

      const addToSummary = (key, value) => ({
        ...summary,
        [key]: [...(summary[key] || []), value]
      });

      if ([ADDON_TYPE.SRT_CAPTIONS, ADDON_TYPE.BURN_IN_CAPTIONS].includes(addonType)) {
        const input = { [addonType]: addonType === ADDON_TYPE.BURN_IN_CAPTIONS ?
          addon[addonType] : [addon[addonType]]
        };
        const [caption] = getCaptions?.(input) || [];
        if (_isEmpty(caption)) return summary;

        const { captionValue: { label }, type } = caption;
        return addToSummary('CAPTIONS', { label, type, cost: addon[addonType].cost });
      }

      if (addonType === ADDON_TYPE.VOICE_OVER_ARTISTS) {
        const { cost, name: label } = addon[addonType];
        return addToSummary('VOICE_OVER_ARTISTS', { label, cost });
      }

      if (addonType === ADDON_TYPE.ADDITIONAL_OUTPUT) {
        const [output] = getAdditionalOutputs?.({ [addonType]: [addon[addonType]] }) || [];
        if (_isEmpty(output)) return summary;

        const { captionValue: { label } } = output;
        return addToSummary('SOCIAL_ITERATIONS', { label, cost: addon[addonType].cost });
      }

      return addToSummary('OTHERS', addon);
    }, {});

  const renderOtherAddonType = (addons) => {
    if (_isEmpty(addons)) return null;

    const { isAddonDescriptionWrapped, shouldShowActions, onChangeAddonStatus, getFormattedAddon } = props;

    // Filter out addons that CommonAddonView would render as null (i.e.
    // getFormattedAddon returns nothing). Without this, we'd render the
    // "Others" heading above an empty body, leaving an unintentional gap.
    const visibleAddons = getFormattedAddon ?
    addons.filter((addon) => {
      const addonType = getAddonType(addon);
      return Boolean(getFormattedAddon(addonType, { [addonType]: addon[addonType] }, null));
    }) :
    addons;

    if (_isEmpty(visibleAddons)) return null;

    return (
      <div>
        <Text heading5>Others</Text>
        {visibleAddons.map((addon) => {
          const addonType = getAddonType(addon);
          return (
            <CommonAddonView
              key={new Date().getMilliseconds().toString()}
              addonType={addonType}
              addon={addon[addonType]}
              isAddonDescriptionWrapped={isAddonDescriptionWrapped}
              shouldShowActions={shouldShowActions}
              onChangeAddonStatus={onChangeAddonStatus}
              aspectRatio={addon[addonType].aspectRatio}
              isNewDesign />);

        })}
      </div>);

  };

  const { addonsList, getAdditionalOutputs, getCaptions } = props;

  const addonsSummary = groupAddons(addonsList, getAdditionalOutputs, getCaptions);

  return (
    <>
      <AddonViewV2 addonType="CAPTIONS" addons={addonsSummary.CAPTIONS} />
      <AddonViewV2 addonType="SOCIAL_ITERATIONS" addons={addonsSummary.SOCIAL_ITERATIONS} />
      <AddonViewV2 addonType="VOICE_OVER_ARTISTS" addons={addonsSummary.VOICE_OVER_ARTISTS} />
      {renderOtherAddonType(addonsSummary.OTHERS)}
    </>);

}

export default GroupedAddonList;